/**
 * Created by maduka on 5/30/19.
 */
(function () {
  'use strict';

  angular
    .module('crewSchedule')
    .controller('CreditHoursCtrl', CreditHoursCtrl);

  function CreditHoursCtrl(modalParams,$uibModalInstance) {
    var vm = this;

    vm.model = {
      creditHours : modalParams.creditHoursList
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    }
  }
}());
